import React, { useState } from 'react';

/** Decorative art shared by the quest, overlay and bloom; a new URL retries after failure. */
export default function LanternArt({ src, alt = '', className, fallback }) {
  const [failedSrc, setFailedSrc] = useState(null);
  if (!src || failedSrc === src) return fallback;
  return <img src={src} alt={alt} className={className} draggable={false} onError={() => setFailedSrc(src)} />;
}
